require('./bootstrap');
require('fslightbox');

// Common libraries
import Swiper from 'swiper/bundle';

//function resetHeight(){
    // reset the body height to that of the inner browser
//    document.body.style.height = window.innerHeight + "px";
//}
// reset the height whenever the window's resized
//window.addEventListener("resize", resetHeight);
// called to initially set the height.
//resetHeight();

// Navigation Button
const elem = document.querySelector('#nav-bg'),
      toggleBtn = document.querySelector('#toggle-btn'),
      toggleLink = document.querySelectorAll('a[id^=link]'),
      navHandler = document.getElementById("navHandler"),
      elemH = elem.getBoundingClientRect().height,
      elemW = elem.getBoundingClientRect().width;

let open = false;
let scale, offsetX, offsetY;

const calculateValues = (() => {
  const w = window.innerWidth;
  const h = window.innerHeight;
  //const cssStyles = getComputedStyle(elem);
  //const offsetValue = Number(cssStyles.getPropertyValue('--offset-value'));
  const offsetValue = Number(getComputedStyle(elem).getPropertyValue('--offset-value'));

  //  Offsets to center the circle
  offsetX = (w/2) - (elemW/2) - offsetValue;
  offsetY = (h/2) - (elemH/2) - offsetValue;

  // Good old pythagoras
  const radius = Math.sqrt((h ** 2)+(w ** 2));
  scale = radius/(elemW/2)/2 + .1; // Add '.1' to compensate for Safari sub pixel blur issue
  return scale;
})


const openMenu = () => {
  elem.style.setProperty("--translate-x", `100%`);
  elem.style.setProperty("--translate-y", `100%`);
  elem.style.setProperty("--scale", 100);
}
const closeMenu = () => {
  elem.style.setProperty("--scale", 1);
  elem.style.setProperty("--translate-x", 0);
  elem.style.setProperty("--translate-y", 0);
}
const animateMenu = () => {
  open ? openMenu() : closeMenu();
};

const toggleMenu = () => {
  open = !open;
  animateMenu();
  toggleBtn.classList.toggle('shown');

  if(open == true) {
    navHandler.style.visibility = "visible";
  } else {
    navHandler.style.visibility = "hidden";
  }

}

const resizeHandler = () => { 
  window.requestAnimationFrame(() => {
    calculateValues();
    animateMenu();
  });
}

calculateValues();

//toggleBtn.onclick = toggleMenu;

var names = '';
for(var i=0; i<toggleLink.length; i++) {
    names += toggleLink[i].name;
}

toggleLink.forEach(btn => {
  btn.addEventListener('click', toggleMenu, false);
});

toggleBtn.addEventListener('click', toggleMenu, false);
window.addEventListener("resize", resizeHandler, false);


var swiper = new Swiper('.swipe1', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 1200,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

var swiper2 = new Swiper('.swipe2', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 900,

  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination2',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

var swiper = new Swiper('.swipe3', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 900,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination3',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

const lightbox2 = new FsLightbox();
lightbox2.props.sources = ['public/img/praxis2.jpg', 'public/img/DrSpohr-Kieferorthophaede-Vollbild-Slider_1920x10802.jpg', 'public/img/lupe.svg'];
lightbox2.props.onInit = () => console.log('Lightbox initialized!');

var left = document.getElementById("logo");
var navi = document.getElementById("naviM");
var stop = (left.offsetTop + 132);

//console.log(stop);

window.onscroll = function (e) {
    var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    //console.log(scrollTop, left.offsetTop);
    // left.offsetTop;

    if (scrollTop >= stop) {
        document.body.style.paddingTop = 68 + 'px';
        left.className = 'stick';
        navi.className = 'stick2';
    } else {
        document.body.style.paddingTop = 0;
        left.className = '';
        navi.className = '';
    }

};

// Smooth Scroll
// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        };
      });
    }
  }
});

// Coded by unlimited.studio – https://unlimited.studio